// extracted by css-extract-rspack-plugin
export default {"version":"VersionName-module__version__scb1j"};